import { render, staticRenderFns } from "./custom-radio-button.vue?vue&type=template&id=09e68c1c&scoped=true&"
import script from "./custom-radio-button.vue?vue&type=script&lang=js&"
export * from "./custom-radio-button.vue?vue&type=script&lang=js&"
import style0 from "./custom-radio-button.vue?vue&type=style&index=0&id=09e68c1c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e68c1c",
  null
  
)

export default component.exports